import { _ as s } from "./atoms-v21329.js";
import { _ as r } from "./atoms-v21330.js";
import { _ } from "./atoms-v21331.js";
var a = s, e = r, t = _;
function h() {
  this.size = 0, this.__data__ = {
    hash: new a(),
    map: new (t || e)(),
    string: new a()
  };
}
var o = h;
export {
  o as _
};
